<div class="container-fluid">
  <!-- Top Navigation -->
  <div class="top-nav">
     <a routerLink="/" routerLinkActive="router-link-active" [routerLinkActiveOptions]="{exact: true}">Home</a>
<a routerLink="/patient-hospital-selection" routerLinkActive="router-link-active" (click)="setRegistrationFlow()">Register</a>
    <a routerLink="/login" routerLinkActive="router-link-active">Sign In</a>
  </div>


  <!-- Main Card -->
  <div class="main-wrapper">
    <div class="register-wrapper">
 <div class="logo-container">
      <img src="assets/logos/logo.png" alt="e-Likita Logo" class="form-logo" fetchpriority="high">
    </div>


      <div class="form-title">
        <div class="form-name">Sign In</div>
        <div class="form-description">Welcome back to e-Likita</div>
      </div>

      <!-- Error Alert -->
      @if(errorMessage) {
      <div class="alert alert-{{ errorType }}">
        <div class="alert-content">
          <div class="alert-message">{{ errorMessage }}</div>
          <button class="alert-close" (click)="clearError()" type="button">
            <span>×</span>
          </button>
        </div>
      </div>
      }

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>mail</mat-icon>
          <input matInput type="email" formControlName="email" required />
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
            Please enter a valid email
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password" required />
          <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button">
            <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <button
          mat-flat-button
          color="primary"
          class="primary-button"
          type="submit"
          [disabled]="loading">
          {{ loading ? 'Signing In...' : 'Sign In' }}
        </button>

        <div class="forgot-password" (click)="resetForgotPassword()">
          Forgot Password? Reset it here
        </div>
      </form>
<!---
      <div class="social-login-wrapper">
        <div class="social-login-head">
          <span>Or Sign In With</span>
        </div>
        <div class="social-login-body">
          <a class="colored-icon" (click)="signInWithGoogle()">G</a>
        </div>
      </div>
-->

    </div>
  </div>
</div>

